<template>
  <form @submit.prevent="submitMessage">
    <b-alert :show="!!error" variant="danger">Bocs, de ezt most elkúrtuk.</b-alert>

    <b-form-group label="1. Név" label-for="author">
      <b-form-input id="author" v-model="author" :disabled="isBusy"></b-form-input>
    </b-form-group>

    <b-form-group>
      <b-button
        variant="outline-primary"
        @click="generateAuthor"
        :disabled="isBusy"
      >Nem tudom a nevem
      </b-button>
    </b-form-group>

    <b-form-group label="2. Most mondd meg a frankót!" label-for="message">
      <b-form-textarea
        id="message"
        v-model="message"
        rows="4"
        placeholder="Ne fogd vissza magad"
        :disabled="isBusy"
      ></b-form-textarea>
      <br>
      <a>3. Puzsér szerintem:</a>
    </b-form-group>
    <b-button-group id="otherButtons">
      <b-button
        type="submit"
        name="liberal"
        @click="setSelectedGenerator"
        :disabled="isSubmitDisabled"
      >Egy fasiszta
      </b-button>
      <b-button
        type="submit"
        name="NERify"
        @click="setSelectedGenerator"
        :disabled="isSubmitDisabled"
      >Egy troll
      </b-button>
      <b-button
        type="submit"
        name="gender"
        @click="setSelectedGenerator"
        :disabled="isSubmitDisabled"
      >Egy szexista bunkó
      </b-button>
    </b-button-group>
    <br/>
    <br>
    <b-button-group id="asis">
      <b-button
        variant="danger"
        type="submit"
        name="asIs"
        @click="setSelectedGenerator"
        :disabled="isSubmitDisabled"
      >Saját véleményem van
      </b-button>
    </b-button-group>
  </form>
</template>

<style>
  #asis {
    width: 100%;
  }
  #otherButtons {
    width: 100%;
  }

</style>

<script>
  import {asIs, gender, generateName, liberal, NERify} from '@/generators'
  import {addMessage, Message} from '@/services/messages'

  const generators = {
    gender,
    liberal,
    NERify,
    asIs
  };

  export default {
    name: 'MessageForm',
    data: () => ({
      author: '',
      message: '',
      error: null,
      isBusy: false,
      selectedGenerator: null,
    }),
    computed: {
      isValid() {
        return !!this.author.length && !!this.message.length
      },
      isSubmitDisabled() {
        return !this.isValid || this.isBusy
      }
    },
    methods: {
      setSelectedGenerator(e) {
        this.selectedGenerator = e.target.name
      },
      generateAuthor() {
        this.author = generateName()
      },
      async submitMessage() {
        this.error = null;
        this.isBusy = true;

        const {author, message, selectedGenerator} = this;

        try {
          const generatedMsg = await generators[selectedGenerator](message);

          await addMessage(Message({author, body: generatedMsg}));

          this.message = ''
        } catch (error) {
          this.error = error
        } finally {
          this.isBusy = false
        }
      }
    },
  }
</script>
